// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { getSettingValueWithoutAssignment } from "@faire/web--source/common/settings/__internal__/getSetting";
import { CONDENSED_BRAND_PAGE_HEADER_TEST_XP_241118 } from "@faire/web-api--source/indigofair/settings/CONDENSED_BRAND_PAGE_HEADER_TEST_XP_241118";

export const getSettingCondensedBrandPageHeaderTestXp = (): boolean =>
  getSettingValueWithoutAssignment(
    CONDENSED_BRAND_PAGE_HEADER_TEST_XP_241118,
    false
  );
